import { MenuItem, Tabs } from "@material-tailwind/react";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormatePrice from "../../utils/FormatePrice";
import EditFoodItem from "../../Modals/EditFoodItem";
import { IoIosMore } from "react-icons/io";
import EditFoodCategory from "../../Modals/EditFoodCategory";
import ConfirmDeleteCategory from "../../Modals/ConfirmDeleteCategory";
import ConfirmDeleteFood from "../../Modals/ConfirmDeleteFood";
import { Menu, MenuButton, MenuItems } from '@headlessui/react';
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import Loader from "../Loader";
import { fetchFoodCategories } from "../../redux/slices/categoriesSlice";

const FoodSideBar = ({searchTerm, data, itemsPerPage, currentPage, setCurrentPage, isLoading, totalRecord,selectedCategoryId, setSelectedCategoryId}) => {
  const MenuItemsPerPage = 50;
  const dispatch = useDispatch();
  const [isFoodDrawer, setIsFoodDrawer]  = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [selected, setSelected] = useState('');
  const menu = useSelector((state) => state?.category);
  const menuList = menu?.category?.data

  useEffect(() =>{
    dispatch(
      fetchFoodCategories({
      searchText: searchTerm,
      pageSize: MenuItemsPerPage,
      pageNumber: currentPage,
    }))
  }, [dispatch, searchTerm, currentPage,]);

  const totalPages = Math.ceil(totalRecord / itemsPerPage);
      
  const handleEditCategory = (item) => {
      setSelected(item);
      setIsDrawerOpen(true);
  };
  const handleDelete = async (item) => {
    setIsDeleteOpen(true);
    setSelected(item)
  };
  const handleDeleteFood = async (item) => {
    setIsDeleteOpen(true);
    setSelected(item)
  };

  const handleEditFood = (item) => {
    setSelected(item);
    setIsFoodDrawer(true);
  };


  return (
      <Tabs
        value={selectedCategoryId || ''}
        orientation="vertical"
        className="mt-10"
       >
        <Tabs.List className="bg-white w-[150px] lg:w-[200px] max-w-sm" >
          <div className="py-2 text-sm lg:text-md font-semibold rounded-tr-md rounded-tl-md text-center bg-[#E7E7E7]">
            Menu Lists
          </div>
          <div className="flex flex-col border border-[#E7E7E7]">
          {menuList?.length > 0 ? (
            menuList.map((item) => (
              <div
                key={item.id}
                className={`${selectedCategoryId === item.id ? "#FFA500" : ""} text-center text-md font-medium mt-3 border-b hover:bg-orange/20 hover:font-semibold cursor-pointer p-[5px]`}
                onClick={() => setSelectedCategoryId(item.id)}
                style={{
                  backgroundColor: selectedCategoryId === item.id ? "#FFA500" : ""
                }}
                >
                  <span className="text-sm lg:text-md">{item.name}</span>
                </div>
              ))
            ) : (
              <p className="text-sm p-3 text-center">No food item(s) to display</p>
            )}
          </div>
        </Tabs.List> 
        <div className="flow-root bg-white w-full overflow-x-auto rounded-tl-xl rounded-tr-xl">
        <div className="h-full">
          <div className="inline-block min-w-full align-middle">
            <table className="min-w-full divide-y divide-gray-300 table-auto p-4 border">
              <thead className="bg-[#593A00] p-1 border-primaryBrown">
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-white">
                    S/N
                  </th>
                  <th scope="col" className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold capitalize text-white">
                  food item
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-start text-sm font-semibold capitalize text-white">
                  description
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold capitalize text-white">
                  price/unit
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold capitalize text-white">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="">
                {isLoading ? (
                   <tr>
                   <td colSpan="5" className="flex justify-center items-center h-[200px]">
                     <Loader />
                   </td>  
                 </tr>
                  ) : data?.length > 0 ? ( 
                    <>
                      {data?.map((item, index) => ( 
                          <tr key={item.id} className="border-b border-b-primaryGray hover:border-b-[#0A0A0A]/40 hover:text-[#0A0A0A]/70 py-4">
                          <td className="px-3 text-xs text-[#0A0A0A]/80 capitalize font-medium">{index + 1}</td>
                          <td className="py-2">
                            <span className="flex items-center px-2">
                              {item?.foodImages && (
                                <img
                                  src={item?.foodImages[0]?.fileUrl}
                                  alt=""
                                  className="h-[60px] w-[60px] object-cover rounded-full cursor-pointer py-2"
                                />
                              )}
                                <span className="ml-2 text-[#0A0A0A] capitalize font-semibold text-sm font-semibold w-40">
                                  {item.name}
                                  </span>
                              </span>
                            </td>
                          <td className="px-3 py-2 text-sm capitalize hover:text-[#0A0A0A]/7 text-start w-80">
                            {item.description}
                          </td>
                          <td className="px-3 text-sm text-primaryRed font-bold">{FormatePrice(item.price)}</td>
                          <td className="px-3 text-sm text-gray-500">{
                            <Menu as="div" className="relative inline-block text-left transition delay-700 duration-300 ease-in-out">
                            <div>
                              <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-md font-semibold text-[#B3B3B3] ring-0 outline-0 hover:bg-gray-50">
                                <IoIosMore />
                              </MenuButton>
                            </div>
                              <MenuItems
                              transition
                              className="absolute right-0 z-50 mt-2 w-fit origin-top-right rounded-md bg-[#DADADA] shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in whitespace-nowrap"
                            >
                              <div className="py-1">
                                <MenuItem>
                                    <button
                                      className="block w-full px-4 py-2 text-sm text-gray-700 data-[focus]:text-gray-900 data-[focus]:outline-none text-center text-[#0A0A0A0A]/70 hover:text-[#0A0A0A] hover:font-medium hover:bg-none" onClick={() => handleEditCategory(item)}>
                                        Edit Menu
                                      </button>
                                  </MenuItem>
                                    <MenuItem>
                                      <button
                                        className="block w-full px-4 py-2 text-sm text-gray-700 data-[focus]:text-gray-900 data-[focus]:outline-none text-center text-[#0A0A0A0A]/70 hover:text-[#0A0A0A] hover:font-medium hover:bg-none" onClick={() => handleDelete(item)}>
                                        Delete Menu
                                      </button>
                                    </MenuItem>
                                    <MenuItem>
                                      <button
                                        className="block w-full px-4 py-2 text-sm text-gray-700 data-[focus]:text-gray-900 data-[focus]:outline-none text-center text-[#0A0A0A0A]/70 hover:text-[#0A0A0A] hover:font-medium hover:bg-none" 
                                        onClick={() => handleEditFood(item)}
                                      >
                                        Edit FoodItem
                                      </button>
                                    </MenuItem>
                                    <MenuItem>
                                      <button
                                        className="block w-full px-4 py-2 text-sm text-gray-700 data-[focus]:text-gray-900 data-[focus]:outline-none text-center text-[#0A0A0A0A]/70 hover:text-[#0A0A0A] hover:font-medium hover:bg-none"
                                        onClick={() => handleDeleteFood(item)}
                                      >
                                        Delete FoodItem
                                      </button>
                                  </MenuItem>
                              </div>
                              </MenuItems>
                            </Menu>
                            }
                          </td>
                        </tr>
                      ))}
                    </>
                    ) : (
                      <p className="text-sm text-center text-primaryRed py-5">No items available for the selected category.</p>
                    )
                  }
              </tbody>
            </table>
            <div className="grid place-items-center mt-10">
            <ResponsivePagination
              current={currentPage}
              total={totalPages}
              onPageChange={setCurrentPage}
              extraClassName="custom-pagination"
            />
            </div>
              <EditFoodItem
                item={selected}
                isOpen={isFoodDrawer}
                onClose={() => setIsFoodDrawer(false)}
              />
              <EditFoodCategory
                item={selected}
                isOpen={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
              />
               <ConfirmDeleteCategory
                isOpen={isDeleteOpen}
                onClose={() => setIsDeleteOpen (false)}
                item={selected}
               />
               <ConfirmDeleteFood
                isOpen={isDeleteOpen}
                onClose={() => setIsDeleteOpen (false)}
                item={selected}
               />
          </div>
        </div>
     </div>
      </Tabs>
  )
}
export default FoodSideBar;